import React, {useState} from "react";

import {
  Button,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Modal,
  Section,
  Select,
  Title,
} from "@allxsmith/bestax-bulma";

import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import {ToastContainer, toast} from "react-toastify";
import {getQueryString} from "../../utils";
import VehicleMakePicker from "../Vehicle/VehicleMakePicker";
import VehicleModelPicker from "../Vehicle/VehicleModelPicker";


export default function CreatePartModal({open, setOpen, endpoint, historicPart, vehicleTypes, makes, models}) {
  const prefilledPart = historicPart ? {
    make: historicPart.part_order ? {} : historicPart.job ? historicPart.job.vehicle.make : historicPart.quote.vehicle.make,
    model: historicPart.part_order ? {} :historicPart.job ? historicPart.job.vehicle.model : historicPart.quote.vehicle.model,
    name: historicPart.name,
    part_number: historicPart.part_number,
    supplier: historicPart.supplier,
    cost: historicPart.cost,
    vehicle_type: historicPart.part_order ? {} : historicPart.job ? historicPart.job.vehicle.type : historicPart.quote.vehicle.type

  } : {
    vehicle_type: vehicleTypes[0],
    make: null,
    model: null
  }

  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);
  let [part, setPart] = useState(prefilledPart || {});
  const [, setTypeahead] = useState();
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  let filteredModels = models ? [...models.results] : [];

  if(part.make && part.make.id && models){
    filteredModels = filteredModels.filter(model => model.make && (model.make.id === part.make.id));
  }

  const typeFields = vehicleTypes;
  const typeObjects = typeFields.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});
  let makeObjects= [];
  let modelObjects = [];
  if(makes){
    makeObjects = makes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});
  }

  if(models){
    modelObjects = models.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});
  }


  const handleMakeUpdate = (e, index) => {
    const toUpdate = {
      target: {
        name: "make",
        value: makeObjects[e.target.value]
      }
    }
    handleChange(toUpdate, index)
  }

  const handleModelUpdate = (e, index) => {
    const toUpdate = {
      target: {
        name: "model",
        value: modelObjects[e.target.value]
      }
    }
    handleChange(toUpdate, index)
  }

  const handleTypeUpdate = (e, index) => {
    const toUpdate = {
      target: {
        name: "vehicle_type",
        value: typeObjects[e.target.value]
      }
    };
    handleChange(toUpdate, index);
  };


  const onClickAction = () => {
    if (checkAllFieldsFilled()) {
      save();
      setPart({})
      setOpen(false);
    } else {
      toast.error("Please fill in all fields", {position: "top-right"});
    }
  };

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  }

  const handlePartSupplierSelect = supplier => {
    let newPart = {...part}
    newPart.supplier = supplier[0];
    setPart(newPart);
  };

  const handleChange = (e, index) => {
    let newPart = {...part};
    newPart[e.target.name] = e.target.value;
    setPart(newPart);
  };

  const checkAllFieldsFilled = () => {
    if (
      false
    ) {
      return false;
    }
    return true;
  };

  const save = () => {
    const url = endpoint + "partlookup";
    const queryString = getQueryString({
      name: part.name,
      part_number: part.part_number,
      make: part.make ? part.make.id : "",
      model: part.model ? part.model.id : "",
      vehicle_type: part.vehicle_type.id
    });
    return axios.get(`${endpoint}partlookup${queryString}`).then((response) => {
      if(response.data.results.length === 0) {
        const conf = {
          method: "post",
          data: part,
          url
        };
        //
        return axios(conf).then(() => {
          dispatch(createSetDataFreshAction(dataFresh + 1));
          setOpen(false);
        });
      } else {
        toast.warning("This part already exists!", {position: "top-right"});
      }
    });

  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      nClick={e => {e.stopPropagation()}}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content className="wider-modal">
        <Section style={{backgroundColor: "white"}}>
          <Title className="is-centered">Create New Part Lookup</Title>
          <Columns isMultiline>
            <Column>
              <VehicleMakePicker
                onChange={handleMakeUpdate}
                vehicle={part}
                makes={makes}
              />
            </Column>
            <Column>
              <VehicleModelPicker
                onChange={handleModelUpdate}
                vehicle={part}
                models={{results: filteredModels}}
              />
            </Column>
            <Column>
              <Field>
                <Control>
                  <label className="label">Type</label>
                  <Select
                    onChange={handleTypeUpdate}
                    name="vehicle_type"
                    value={part.vehicle_type ? part.vehicle_type.id : typeFields[0].id}
                  >
                    {typeFields.map(value =>
                      <option key={value.id} value={value.id}>
                        {value.name}
                      </option>
                    )}
                  </Select>
                </Control>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Part Name</label>
                <Control>
                  <Input
                    type="text"
                    name="name"
                    onChange={handleChange}
                    value={part.name || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Part Number</label>
                <Control>
                  <Input
                    type="text"
                    name="part_number"
                    onChange={handleChange}
                    value={part.part_number || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Supplier</label>
                <Control>
                  <AsyncTypeahead
                    useCache={false}
                    id="typeahead"
                    labelKey="display_name"
                    minLength={2}
                    name={"supplier"}
                    onSearch={handleSearch}
                    onChange={handlePartSupplierSelect}
                    placeholder={"Search Supplier"}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    isLoading={isLoading}
                    selected={part.supplier && part.supplier.id ? [part.supplier] : []}
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Cost</label>
                <Control className="has-icons-left">
                  <Input
                    type="text"
                    name="cost"
                    onChange={handleChange}
                    value={part.cost || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Customer Charge</label>
                <Control className="has-icons-left">
                  <Input
                    type="text"
                    name="customer_cost"
                    onChange={handleChange}
                    value={part.customer_cost || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Button
                color="info"
                onClick={() => {
                  setPart({});
                  setOpen(false);
                }}
                isFullWidth
              >
                Cancel
              </Button>
            </Column>
            <Column>
              <Button color="danger" onClick={onClickAction} isFullWidth>
                Save Part Lookup
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
